export default __webpack_public_path__ + "static/media/5696349.686d9d51.png";